import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { length, required, email, min, max, size } from 'vee-validate/dist/rules'

export const init = (Vue) => {
  extend('length', length)
  extend('size', {
    ...size,
    message: (_name, { size }) => {
      const sizeInMB = size / 1024 // convert KB → MB, 2 decimals
      return `The file size must be less than ${sizeInMB} MB`
    },
  })
  extend('min', {
    ...min,
    message: (_name, { length }) => `Minimum ${length} characters required`,
  })
  extend('max', {
    ...max,
    message: () => ``,
  })
  extend('businessDescriptionChars', {
    message: 'Only letters, numbers, spaces, and basic punctuation are allowed',
    validate: (value) => /^[a-zA-Z0-9\s.,;:!?'"()\-/]*$/.test(value),
  })
  extend('required', {
    ...required,
    message: (field) => `${field} is required`,
  })
  extend('email', {
    ...email,
    message: 'Email is invalid',
  })
  extend('mottoEmailDomain', {
    message: 'New email must belong to "@mottomortgage.com" domain.',
    validate: (value) => value.endsWith('@mottomortgage.com'),
  })
  extend('validPhoneNumber', {
    validate: (value) => value.length === 0 || value.length === 12,
  })

  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)
}
